const testimonials = [
  {
    name: "Captain Mike T.",
    location: "Jupiter, FL",
    rating: 5,
    text: "I run a charter boat out of Jupiter Inlet and had a four-day Bahamas trip booked with six clients. Two days before departure, one of my regulars realized his passport had expired four months earlier. I called Fast Passport Center in a panic. They processed his renewal in two business days — he made the trip, and we didn't lose a $12,000 charter. I now tell every client to check their passport at booking, but I also keep Fast Passport Center's number in my phone just in case.",
    service: "Passport Renewal",
  },
  {
    name: "Barbara S.",
    location: "Juno Beach, FL",
    rating: 5,
    text: "My husband and I are Cardinals season ticket holders and had planned a road trip to St. Louis for a weekend series in May. I pulled our passports out three weeks before the trip and discovered mine had expired in January. I started the process with Fast Passport Center on a Tuesday, shipped everything from the UPS Store on Indiantown Road, and had my new passport by the following Monday. We made the trip, saw the Cardinals win in extra innings, and I have recommended Fast Passport Center to every fan in our section at Roger Dean Stadium.",
    service: "Passport Renewal",
  },
  {
    name: "David R.",
    location: "Jupiter, FL",
    rating: 5,
    text: "My daughter's travel softball team was invited to a tournament in Puerto Rico. Twelve girls, twelve passports to check. Two of them had expired — including my daughter's, which I swore I renewed last year. The tournament was in ten days. Fast Passport Center walked me through exactly what we needed for a child passport renewal, helped me schedule the acceptance clerk visit at the Jupiter post office, and processed both renewals in four business days. Both girls played in Puerto Rico. I cannot express how grateful I am.",
    service: "Child Passport",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function JupiterTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Jupiter Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Jupiter, Juno Beach, and northern Palm Beach County residents who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}